import {
  Box,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import {
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useInfiniteQuery } from '@tanstack/react-query';
import AdminNavbar from '../../components/Navbars/AdminNavbar';
import TerminalsTableRow from './TerminalsTableRow';

const TerminalsTable = ({ title, columns }) => {
  const textColor = useColorModeValue('gray.700', 'white');
  const tableContainerRef = React.useRef(null);
  const [sorting, setSorting] = React.useState([]);
  const token = useAuthHeader();
  const [globalFilter, setGlobalFilter] = React.useState('');

  const { data, isLoading } = useInfiniteQuery(
    ['terminals', sorting],
    async () => {
      const res = await axios.get(`/api/v1/terminal`, {
        headers: { Authorization: token() },
      });
      const fetchedData = await res.data;
      return fetchedData;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  const flatData = React.useMemo(
    () => data?.pages?.flatMap(page => page) ?? [],
    [data]
  );

  const table = useReactTable({
    data: flatData,
    columns,
    state: {
      sorting,
      globalFilter,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableGlobalFilter: true,
  });

  const { rows } = table.getRowModel();

  console.log('rows:', rows);

  if (isLoading) {
    return <>Loading...</>;
  }

  return (
    <>
      <Box>
        <AdminNavbar
          logoText={'SURELLE DASHBOARD'}
          initialValue={globalFilter ?? ''}
          onChange={e => setGlobalFilter(e)}
          debounce={500}
        />
      </Box>
      <Box p="6px 0px 22px 0px">
        <Text fontSize="xl" color={textColor} fontWeight="bold">
          {title}
        </Text>
      </Box>

      <Box overflowX="auto" maxH="800px" ref={tableContainerRef}>
        <Table variant="striped" color={textColor}>
          <Thead>
            {table.getHeaderGroups().map(headerGroup => (
              <Tr key={headerGroup.id} my=".8rem" color="gray.400">
                {headerGroup.headers.map((header) => {
                  return (
                    <Th key={header.id} color="gray.400">
                      <div
                        className={
                          header.column.getCanSort()
                            ? 'cursor-pointer select-none'
                            : undefined
                        }
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        {header.column.columnDef.header}
                        {{
                          asc: ' 🔼',
                          desc: ' 🔽',
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    </Th>
                  );
                })}
              </Tr>
            ))}
          </Thead>
          <Tbody>
            {rows.map(row => {
              return <TerminalsTableRow key={row.id} row={row} />;
            })}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};

export default TerminalsTable;
